import { render, staticRenderFns } from "./GridWorkBench.vue?vue&type=template&id=8877a6d2&scoped=true&"
import script from "./GridWorkBench.vue?vue&type=script&lang=js&"
export * from "./GridWorkBench.vue?vue&type=script&lang=js&"
import style0 from "./GridWorkBench.vue?vue&type=style&index=0&id=8877a6d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8877a6d2",
  null
  
)

export default component.exports